var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page, ComponentInstances } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import '../../components/header';
import '../../components/leftMenu';
import './addSystem.css';
import "../../components/tree";
import * as authorization from "../../lib/authorization";
import * as ajax from '../../app-lib/ajax_proxy';
var HeaderModel = /** @class */ (function (_super) {
    __extends(HeaderModel, _super);
    function HeaderModel(root) {
        var _this = _super.call(this, '/api/user/role/getfolders', root, {}) || this;
        _this.rolename = ko.observable('');
        _this.fid = ko.observable('');
        _this.roleid = ko.observable('');
        //	roleN = ko.observable('');
        _this.roleC = ko.observable('');
        _this.choose_index1 = ko.observableArray();
        _this.names = ko.observable('');
        _this.commens = ko.observable('');
        //	guanli = ko.observable(1);
        //shezhi = ko.observable(0);
        _this.popur = ko.observable(0);
        //	choose_index = ko.observableArray();
        _this.choose_indexpages = ko.observableArray();
        _this.isEdit = ko.observable(false);
        //流程
        _this.ABCArr = ko.observableArray([
            { id: "1", name: "A", checked: ko.observable(false) },
            { id: "2", name: "B", checked: ko.observable(false) },
            { id: "3", name: "C", checked: ko.observable(false) }
        ]);
        //
        _this.choose_index2 = ko.observableArray();
        //  所见范围url
        _this.lookUrl = ko.observable(undefined);
        //首次访问
        _this.visit = ko.observable();
        //审核权限值
        _this.audit = ko.observable();
        //所见部门id
        _this.departmentId = ko.observableArray([]);
        return _this;
    }
    HeaderModel.prototype.saveid = function () {
        var _this = this;
        if (this.rolename().length > 12) {
            return alert('角色名太长');
        }
        if (this.rolename().trim() == '' || this.rolename() == null) {
            return alert('角色名不能为空');
        }
        //console.log(this.rolename());
        if (this.choose_indexpages().length == 0) {
            return alert('模块权限不能为空');
        }
        ajax.post("/api/user/role/addroles", {
            role_name: this.rolename().trim(),
            //	folder_id: this.choose_index(),
            button_id: this.choose_index1(),
            page_id: this.choose_indexpages(),
            folder_type: this.choose_index2(),
            visit: this.visit(),
            audit: this.audit(),
            departmentId: this.departmentId()
        }).then(function (a) {
            if (a.message == "角色名重复") {
                return window.popBox.show(a.message);
            }
            if (a.status == "0") {
                _this.rolename("");
                _this.commens("");
                _this.choose_index1 = ko.observableArray([]);
                //this.choose_index = ko.observableArray([]);
                _this.choose_indexpages = ko.observableArray([]);
                window.popBox.show("新增成功");
                _this.lookUrl(undefined);
                setTimeout(function () {
                    window.history.back();
                }, 100);
            }
        });
    };
    HeaderModel.prototype.back = function () {
        this.names('');
        this.commens('');
        //	this.roleN('');
        window.history.back();
    };
    HeaderModel.prototype.updateid = function (fid) {
        // this.choose_index().forEach(element => {
        // });
        // this.choose_index1().forEach(element => {
        // });
        // this.choose_indexpages().forEach(element => {
        // });
        var _this = this;
        if (this.rolename().length > 12) {
            alert('角色名太长');
            return;
        }
        if (this.rolename().trim() == '' || this.rolename() == null) {
            return alert('角色名不能为空');
        }
        if (this.choose_indexpages().length == 0) {
            return alert('模块权限不能为空');
        }
        ajax.put('/api/user/role/updateroles', {
            id: this.fid(),
            role_name: this.rolename(),
            //	folder_id: this.choose_index(),
            button_id: this.choose_index1(),
            page_id: this.choose_indexpages(),
            folder_type: this.choose_index2(),
            visit: this.visit(),
            audit: this.audit(),
            departmentId: this.departmentId()
        }).then(function (s) {
            console.log(s);
            if (s.message == "角色名重复") {
                return window.popBox.show(s.message);
            }
            if (s.status == "0") {
                _this.choose_index1 = ko.observableArray([]);
                //this.choose_index = ko.observableArray([]);
                _this.choose_indexpages = ko.observableArray([]);
                _this.roleid('');
                window.popBox.show('修改成功');
                setTimeout(function () {
                    window.history.back();
                }, 100);
            }
            else {
                window.popBox.show(s.message);
            }
        });
    };
    HeaderModel.prototype.disp = function (m, e) {
        var div = e.currentTarget;
        div.classList.add("active");
        div.nextElementSibling.classList.remove("active");
    };
    // GuanLi(m: any, e: any) {
    // 	let div = e.currentTarget as HTMLElement
    // 	div.classList.add("active")
    // 	div.nextElementSibling.classList.remove("active")
    // 	this.shezhi(0)
    // 	this.guanli(1)
    // }
    // SheZhi(m: any, e: any) {
    // 	let div = e.currentTarget as HTMLElement
    // 	div.classList.add("active")
    // 	div.previousElementSibling.classList.remove("active")
    // 	this.shezhi(1)
    // 	this.guanli(0)
    // }
    HeaderModel.prototype.btn_choosepage = function (res, index) {
        var model = this.viewModel();
        if (this.choose_indexpages.indexOf(index) == -1) {
            this.choose_indexpages.push(index);
        }
        else {
            this.choose_indexpages.remove(index);
        }
        return true;
    };
    //选中
    HeaderModel.prototype.btn_choose1 = function (res, index) {
        var model = this.viewModel();
        if (this.choose_index1.indexOf(index) == -1) {
            this.choose_index1.push(index);
        }
        else {
            this.choose_index1.remove(index);
        }
        return true;
    };
    HeaderModel.prototype.btn_choose2 = function (res, index) {
        if (this.choose_index2.indexOf(index) == -1) {
            this.choose_index2.push(index);
        }
        else {
            this.choose_index2.remove(index);
        }
        return true;
    };
    //选中
    // btn_choose(res: any, index: any) {
    // 	let model = this.viewModel();
    // 	//console.log("666::"+this.choose_index.indexOf(index));
    // 	if (this.choose_index.indexOf(index) == -1) {
    // 		this.choose_index.push(index);
    // 	} else {
    // 		this.choose_index.remove(index);
    // 	}
    // 	//  console.log(this.choose_index())
    // 	return true;
    // }
    //全选
    // btn_choose_all(event: any) {
    // 	let vm: any = this.viewModel();
    // 	if (event.target.checked) {
    // 		this.choose_index.removeAll();
    // 		for (var i in vm.data.folders) {
    // 			//console.log(vm.data.folders[i].id);
    // 			this.choose_index.push(vm.data.folders[i].id);
    // 		}
    // 	} else {
    // 		this.choose_index.removeAll();
    // 	}
    // 	return true;
    // }
    // ie设置
    HeaderModel.prototype.ieS = function () {
        var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串  
        var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
        if (isIE) {
            var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
            reIE.test(userAgent);
            var fIEVersion = parseFloat(RegExp["$1"]);
            if (fIEVersion == 7) {
                return true;
            }
            else if (fIEVersion == 8) {
                return true;
            }
            else if (fIEVersion == 9) {
                return true;
            }
            else if (fIEVersion == 10) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    HeaderModel.prototype.btn_choose_all1 = function (event) {
        var vm = this.viewModel();
        if (this.ieS()) {
            if (event.srcElement.checked) {
                this.choose_indexpages.removeAll();
                for (var i in vm.data.po) {
                    //	console.log(vm.data.po[i].id);
                    this.choose_indexpages.push(vm.data.po[i].id);
                }
            }
            else {
                this.choose_indexpages.removeAll();
            }
        }
        else {
            if (event.target.checked) {
                this.choose_indexpages.removeAll();
                for (var i in vm.data.po) {
                    //	console.log(vm.data.po[i].id);
                    this.choose_indexpages.push(vm.data.po[i].id);
                }
            }
            else {
                this.choose_indexpages.removeAll();
            }
        }
        return true;
    };
    HeaderModel.prototype.Popur = function () {
        if (this.popur() == 1) {
            this.popur(0);
        }
        else {
            var str = '/api/org/showdepa1?roleId=' + this.fid();
            this.lookUrl(str);
            this.popur(1);
            var tree1 = ComponentInstances["tree_plus"];
            console.log(tree1.getCheckedNode(), '=====================勾选');
            for (var i = 0; i < this.departmentId().length; i++) {
                for (var key in tree1.rData) {
                    if (tree1.rData[key].path) {
                        if (tree1.rData[key].id == this.departmentId()[i]) {
                            // console.log(depa[key].id)
                            // mynode.push()
                            tree1.rData[key].isChecked = true;
                        }
                    }
                }
            }
        }
    };
    HeaderModel.prototype.checkdepa = function (data) {
        if (data.id == '0') {
            window.popBox.show('根节点无法操作！');
        }
        else {
            data.isChecked = !data.isChecked;
        }
    };
    HeaderModel.prototype.firstvisit = function (check) {
        if (this.viewModel().data.departmentName() == '') {
            return window.popBox.show('请先选择范围权限');
        }
        if (this.visit() == '0') {
            this.visit('1');
        }
        else {
            this.visit('0');
        }
        return true;
    };
    HeaderModel.prototype.accounts = function (parent, index) {
        console.log(index);
        if (this.viewModel().data.departmentName() == '') {
            return window.popBox.show('请先选择范围权限');
        }
        for (var i in parent.audit()) {
            if (index == i) {
                if (this.audit() && this.audit() == parent.audit()[i].name) {
                    this.audit('');
                }
                else {
                    this.audit(parent.audit()[i].name);
                }
            }
            else {
            }
        }
        return true;
    };
    HeaderModel.prototype.surePopur = function () {
        var _this = this;
        var tree1 = ComponentInstances["tree_plus"];
        var check = tree1.getCheckedNode();
        //let list = vm.list as { id: string }[]
        var arr = [];
        //arr=check.map(p=>p.id);
        for (var i in check) {
            arr.push({ id: check[i].id, name: check[i].name, pid: check[i].pid });
        }
        console.log(arr);
        //  console.log(check);
        //  console.log(arr);
        if (arr[0].id == '0') {
            arr.splice(0, 1);
        }
        ajax.post('/api/sys/departmentname', {
            list: arr
        }).then(function (r) {
            _this.viewModel().data.departmentName(r.data.names);
            _this.departmentId(r.data.list);
        });
        if (arr.length == 0) {
            this.visit('0');
            this.audit('');
        }
        console.log(this.visit());
        console.log(this.audit());
        this.popur(0);
    };
    HeaderModel.prototype.onViewModelSetting = function (d) {
        var rolearry = d.data.role;
        var folderArry = d.data.folders;
        var poArry = d.data.po;
        var tbArry;
        // for (const key in folderArry) {
        // 	let boolea = folderArry[key].boolea;
        // 	if (boolea == 1)
        // 		this.choose_index.push(folderArry[key].id);
        // }
        for (var key in poArry) {
            var boolea = poArry[key].boo;
            tbArry = poArry[key].tb;
            if (boolea == 1) {
                this.choose_indexpages.push(poArry[key].id);
                for (var i in tbArry) {
                    var ischeck = tbArry[i].bool;
                    if (poArry[key].pageName == '信息池') {
                        if (ischeck == 1)
                            this.choose_index1.push(tbArry[i].id);
                    }
                    if (poArry[key].pageName == '文件柜') {
                        if (ischeck == 1)
                            this.choose_index2.push(tbArry[i].id);
                    }
                }
            }
        }
        if (d.data.departmentId) {
            this.departmentId(d.data.departmentId);
        }
        else {
            this.departmentId([]);
        }
        d.data.audit = ko.observableArray(d.data.audit);
        for (var i in d.data.audit()) {
            d.data.audit()[i].checked = ko.observable(d.data.audit()[i].checked);
            if (d.data.audit()[i].checked() == true) {
                this.audit(d.data.audit()[i].name);
            }
        }
        console.log(this.choose_index1(), this.choose_index2());
        if (rolearry.length > 0) {
            //	this.roleN(rolearry[0].roleName);
            this.rolename(rolearry[0].roleName);
            this.roleC(rolearry[0].roleComment);
            this.roleid(rolearry[0].id);
        }
        //d.data.visit=ko.observableArray(d.data.visit);
        // for( let k in d.data.visit() ){
        // 	d.data.visit()[k].checked=ko.observable(d.data.visit()[k].checked);
        // }
        this.visit(d.data.visit[0].checked ? '1' : '0');
        d.data.departmentName = ko.observable(d.data.departmentName);
        return Promise.resolve(false);
    };
    HeaderModel.prototype.reset = function () {
        //this.roleN('');
        this.roleid('');
        this.rolename("");
        this.commens("");
        this.lookUrl(undefined);
        this.choose_index1.removeAll();
        //this.choose_index.removeAll();
        this.choose_index2([]);
        this.departmentId([]);
        this.visit('');
        this.audit('');
        this.choose_indexpages.removeAll();
    };
    HeaderModel.prototype.loadbubble = function () {
        var arr = [];
        for (var i = 0; i < 7; i++) {
            arr.push(localStorage.getItem(i.toString()));
        }
        return ajax.post('/api/statistics/smessage', { userId: authorization.getUserId(), time: arr }).then(function (d) {
            ko.postbox.publish('leftMenu_myProject', d.data.count0);
            ko.postbox.publish('leftMenu_myFollowProject', d.data.count1);
            ko.postbox.publish('leftMenu_noFollowNews', d.data.count2);
            ko.postbox.publish('leftMenu_waitProjectNews', d.data.count3);
            ko.postbox.publish('leftMenu_signgedProjectNews', d.data.count4);
            ko.postbox.publish('leftMenu_abandonProjectNews', d.data.count5);
            ko.postbox.publish('leftMenu_auditMessage', d.data.count6);
        });
    };
    HeaderModel.prototype.loadnum = function () {
        return ajax.get('/api/statistics/message', { userid: authorization.getUserId(), loginTime: new Date()["Format"]('yyyy-MM-dd hh:mm:ss') }).then(function (d) {
            ko.postbox.publish('leftMenu_allProject', d.data.allProject);
            ko.postbox.publish('leftMenu_followProject', d.data.followProject);
            ko.postbox.publish('leftMenu_nofollow', d.data.nofollow);
            ko.postbox.publish('leftMenu_waitProject', d.data.waitProject);
            ko.postbox.publish('leftMenu_signgedProject', d.data.signgedProject);
            ko.postbox.publish('leftMenu_abandonProject', d.data.abandonProject);
            ko.postbox.publish('leftMenu_noReadProject', d.data.noReadProject);
        });
    };
    HeaderModel.prototype.load = function () {
        return Promise.all([this.loadnum(), this.loadData()]).then(function () { });
    };
    return HeaderModel;
}(KnockoutModel));
var mModel = /** @class */ (function (_super) {
    __extends(mModel, _super);
    function mModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    mModel.prototype.init = function () {
        this.hm = new HeaderModel(this.container.querySelector('.Myproject'));
        this.hm.choose_index1 = ko.observableArray();
        //this.hm.choose_index = ko.observableArray();
        this.hm.choose_indexpages = ko.observableArray();
    };
    mModel.prototype.update = function (arg) {
        ko.postbox.publish("isSelectChilen", true);
        this.hm.reset();
        this.hm.id = '';
        this.hm.data.id = arg.routeData.query['id'];
        if (arg.routeData.query.id) {
            this.hm.isEdit(true);
        }
        else {
            this.hm.isEdit(false);
        }
        this.hm.fid(arg.routeData.query['id']);
        return this.hm.load();
    };
    return mModel;
}(Page));
export default mModel;
